"use client"

import { useCallback, useEffect, useState } from "react"

const STORAGE_KEY = "recently-viewed"
const MAX_ITEMS = 10

/**
 * Hook to track recently viewed product handles in localStorage.
 * Returns empty array during SSR.
 */
export function useRecentlyViewed() {
  const [recentlyViewed, setRecentlyViewed] = useState<string[]>([])

  // Load from localStorage on mount (client-only)
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored)
        if (Array.isArray(parsed)) {
          setRecentlyViewed(parsed.slice(0, MAX_ITEMS))
        }
      }
    } catch {
      // Ignore parse errors
    }
  }, [])

  const addToRecentlyViewed = useCallback((handle: string) => {
    setRecentlyViewed((prev) => {
      // Deduplicate: remove if already exists, add to front
      const filtered = prev.filter((h) => h !== handle)
      const updated = [handle, ...filtered].slice(0, MAX_ITEMS)

      // Persist to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
      } catch {
        // Ignore quota errors
      }

      return updated
    })
  }, [])

  return { recentlyViewed, addToRecentlyViewed }
}
